meedy.factory('meedy.heartbeatModel', ['$rootScope', 'meedy.baseModel', 'meedy.heartbeatService',
    function($rootScope, baseModel, heartbeatService) {

        function HeartbeatModel() {

            this.heartbeat = function() {
                heartbeatService.heartbeat().then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.HEARTBEAT.HEARTBEAT.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.HEARTBEAT.HEARTBEAT.ERROR, error);
                    }
                )
            };

            this.heartbeatEDM = function(inEdm) {
                heartbeatService.heartbeatEDM(inEdm).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.HEARTBEAT.HEARTBEAT_EDM.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.HEARTBEAT.HEARTBEAT_EDM.ERROR, error);
                    }
                )
            };

        }

        return new HeartbeatModel();
    }
]);
